<template>
  <div class="container">
    <div class="head">
      <div class="title">
        <div class="text">“1+16+129+X”游客投诉处置运行情况</div>
        <div class="right" v-if="recordList_new.length > 0">
          <div class="branch">-{{ deductionScore.toFixed(2) }}</div>
          <div class="num">{{ (sumScore - deductionScore).toFixed(2) }}/{{ sumScore.toFixed(1) }}</div>
        </div>

        <!-- 没有扣分记录 -->
        <div v-if="recordList_new.length == 0" class="no-de">未扣分</div>
      </div>
      <!-- <div class="rules">
        <div class="tit" @click="navTo()">
          <span>评分细则</span>
          <img class="r-img" src="@/assets/image/t-right.png" />
        </div>
      </div>-->
    </div>
    <!-- 没有扣分记录提示 -->
    <div v-if="recordList_new.length == 0" class="noData-bg">
      <nodata :noData="noData"></nodata>
    </div>
    <template v-if="recordList_new.length > 0">
      <!-- 老功能 -->
      <!-- <deducList :recordList="recordList" @navToDetail="navToDetail" @queryMore="queryMore"></deducList> -->

      <!-- 新功能 -->
      <deducList :recordList="recordList_new" @navToDetail="navToDetail" @navToALL="queryMore"
        :totalElements="totalElements"></deducList>
    </template>
  </div>
</template>
<script>
// import Vue from 'vue';
import nodata from "@/pages/appraise/components/nodata"; // 没有数据
// import deducList from "../components/deducList"; // 扣分列表
import deducList from "../components/deducList_new.vue";//新需求
import api from "@/service/modules/appraiseNew.js";
import { } from "vant";
// Vue.use(Picker);
export default {
  components: {
    nodata,
    deducList
  },

  data() {
    return {
      id: "1",
      pageSize: 10,
      noData: {
        title: "没有扣分记录"
      },
      recordList: [],
      recordList_new: [],
      scoreObj: {},
      params: {
        area: this.$route.query.area ? this.$route.query.area : 530100,
        year: this.$route.query.year ? this.$route.query.year : 2020,
        quarter: this.$route.query.quarter ? this.$route.query.quarter : 3,
        currentPage: 1,
        pageSize: 5
      },
      totalElements: 0,
      deductionScore: 0,
      sumScore: 3.0
    };
  },

  computed: {},

  watch: {},
  async created() {
    await this.getComplainByB1();
    await this.getComplainByB2();
    await this.getComplainByB3();
  },
  methods: {

    getComplainByB1() {
      // {year: 2020, quarter: 3, area: 530100, currentPage: 1, pageSize: 5}
      const _this = this;
      return new Promise((resovle, reject) => {
        api.getComplainByB1(this.params).then(res => {
          console.log('----获取的数据B1:', res);
          _this.deductionScore = 0;
          _this.recordList_new = [];
          _this.totalElements = 0;
          if (res.ret == 0) {
            _this.deductionScore += res.data.deduction / 100;
            _this.sumScore = res.data.sumScore / 100;
            _this.totalElements += res.data.resVOS.totalElements;
            if (res.data.resVOS.content && res.data.resVOS.content.length > 0) {
              let obj = {
                id: 1, show: false, subName: '投诉5分钟内未响应', dealType: res.data.resVOS.content[0].dealType, subList: res.data.resVOS.content, totalPages: res.data.resVOS.totalPages
              }
              _this.recordList_new.push(obj);
            }
          }
          resovle(true);
        })
      })

    },
    getComplainByB2() {
      const _this = this;
      return new Promise((resolve, reject) => {
        api.getComplainByB2(this.params).then(res => {
          console.log('-----获取的数据B2：', res);
          if (res.ret == 0) {
            _this.deductionScore += res.data.deduction / 100;
            _this.totalElements += res.data.resVOS?.totalElements ?? 0;
            // if(res.data.resVOS && res.data.resVOS.content && res.data.resVOS.content.length > 0){
            let obj = {
              id: 2, 
              show: false, 
              subName: '投诉超过24小时未办结情况', 
              dealType: res.data.resVOS?.content[0]?.dealType ?? "B2",
              subList: res.data.resVOS?.content ?? [],
               totalPages: res.data.resVOS?.totalPages ?? 0
            }
            _this.recordList_new.push(obj);
            // }
          }
          resolve(true);
        })
      })
    },
    getComplainByB3() {
      const _this = this;
      return new Promise((resolve, reject) => {
        api.getComplainByB3(this.params).then(res => {
          console.log('-----获取的数据B3：', res);
          if (res.ret == 0) {
            _this.deductionScore += res.data.deduction / 100;
            _this.totalElements += res.data.resVOS?.totalElements ?? 0;
            if (res.data.resVOS && res.data.resVOS.content && res.data.resVOS.content.length > 0) {
              let obj = { id: 3, show: false, subName: '投诉办结率24小时未达95%', dealType: res.data.resVOS.content[0].dealType, subList: res.data.resVOS.content, totalPages: res.data.resVOS.totalPages }
              _this.recordList_new.push(obj);
            }
          }
          resolve(true);
        })
      })
    },

    queryMore(value) {
      // this.pageSize += 10;
      // this.findAllForApp();
      // console.log('----点击更多:',value);
      if (value.dealType === 'B1') {
        this.$router.push({ path: '/appraise/deducList_FivemitnusAll', query: { dealType: value.dealType, ...this.params } });
      } else if (value.dealType === 'B2') {
        this.$router.push({ path: '/appraise/deducList_twfoNOAll', query: { dealType: value.dealType, ...this.params } });
      } else if (value.dealType === 'B3') {
        this.$router.push({ path: '/appraise/deducList_twfoAll', query: { dealType: value.dealType, ...this.params } });
      }
    },
    navTo() {
      this.$router.push({
        path: "/appraise/scoringList",
        query: {}
      });
    },
    navToDetail(item) {
      const { year, areaName, quarter } = this.$route.query;
      console.log('----item:', item);
      if (item.dealType === 'B1') {
        this.$router.push({
          path: '/appraise/fiveMunites', query: {
            orderNo: item.orderNo,
            orderSubNo: item.orderSubNo,
            year: year,
            areaName: areaName,
            quarter: quarter,
            isExceed: item.isExceed
          }
        });
      } else if (item.dealType === 'B2') {
        this.$router.push({
          path: '/appraise/twentyFourHours', query: {
            orderNo: item.orderNo,
            orderSubNo: item.orderSubNo,
            year: year,
            areaName: areaName,
            quarter: quarter,
            dealType: 'B2',
            isExceed: item.isExceed
          }
        });
      } else if (item.dealType === 'B3') {
        this.$router.push({
          path: '/appraise/nintyFivePercent', query: {
            id: item.id,
            year: year,
            areaName: areaName,
            quarter: quarter,
            isExceed: item.isExceed
          }
        });
      }
      // let path = '';
      // if(item.dealType === 'B1'){
      //   path = `/appraise/fiveMunites?orderNo=${item.orderNo}&orderSubNo=${item.orderSubNo}&year=${year}&areaName=${areaName}&quarter=${quarter}`;
      // }else if(item.dealType === 'B2'){
      //   path = `/appraise/twentyFourHours?orderNo=${item.orderNo}&orderSubNo=${item.orderSubNo}&year=${year}&areaName=${areaName}&quarter=${quarter}&dealType=B2`;
      // }else if(item.dealType === 'B3'){
      //   path = `/appraise/nintyFivePercent?id=${item.id}&year=${year}&areaName=${areaName}&quarter=${quarter}`;
      // }
      // this.$router.push({ path });
    }
  },
};
</script>
<style scoped lang="less">
.container {
  min-height: 100vh;
  background: rgba(251, 251, 251, 1);
  display: flex;
  flex-direction: column;

  .noData-bg {
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1;
  }

  .head {
    background: #fff;
    padding: 24px 12px;
    margin-bottom: 24px;

    .title {
      line-height: 22px;
      display: flex;
      justify-content: space-between;

      .text {
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        line-height: 28px;
        padding-right: 12px;
      }

      .right {
        line-height: 22px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        text-align: right;

        .branch {
          height: 22px;
          font-size: 22px;
          font-family: DIN-Medium, DIN;
          font-weight: 500;
          color: rgba(255, 77, 77, 1);
          line-height: 22px;
          text-align: right;
        }

        .num {
          font-size: 14px;
          font-family: DIN-Medium, DIN;
          font-weight: 500;
          color: rgba(153, 153, 153, 1);
          line-height: 22px;
        }
      }

      .no-de {
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(54, 179, 116, 1);
        line-height: 22px;
        width: 88px;
        text-align: right;
        margin-top: 3px;
      }
    }

    .rules {
      display: flex;
      justify-content: space-between;
      margin-top: 12px;
      color: #666666;
      font-size: 14px;

      .tit {
        display: flex;
        color: #999;
        font-size: 12px;

        .r-img {
          width: 12px;
          height: 12px;
          margin-left: 4px;
        }
      }

      .num {
        color: #999;
      }
    }
  }
}
</style>
